import React from 'react';

import useWebsiteSetting, {useServicedata} from "../FetchAPI";



export default function DataContent() {
    const [webSetting] = useWebsiteSetting();
    const [servicedata] = useServicedata();
  return (
    <>

  {/* Services Section Start */}
      <section className="services-section py-5">
        <div className="container">
          <div className="services-header text-center mb-5">
            <span className="services-badge">Our Services</span>
            <h2 className="services-title"> {webSetting.service_title}</h2>
            <p className="services-subtitle">
              Fast, Reliable and Professional Documentation Services Across India
            </p>
          </div>
          <div className="row g-4">
            {servicedata?.map((value, index) => (
              <div key={value.id || index} className="col-lg-2 col-md-4 col-sm-6">
                <div className="service-card">
                  <div className="service-icon">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: value.icon,
                      }}
                    ></div>
                  </div>
                  <h4>{value.name}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section End */}


    </>
  );
}
